/**
 * Loading spinner component
 */

import styles from "./Spinner.module.css";

/**
 * Spinner sizes
 */
export type SpinnerSize = "small" | "medium" | "large";

/**
 * Spinner component props
 */
export interface SpinnerProps {
  /** Spinner size */
  size?: SpinnerSize;
  /** Accessible label */
  label?: string;
  /** Center in container */
  centered?: boolean;
}

/**
 * Loading spinner with accessibility support
 */
export function Spinner({
  size = "medium",
  label = "Cargando...",
  centered = false,
}: SpinnerProps): React.ReactElement {
  const classNames = [
    styles.spinner,
    styles[size],
    centered ? styles.centered : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classNames} role="status" aria-label={label}>
      <div className={styles.bugContainer}>
        <div className={styles.bug}>🐛</div>
        <div className={styles.dots}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <span className={styles.srOnly}>{label}</span>
    </div>
  );
}

export default Spinner;
